import { render, staticRenderFns } from "./ProfileTabsTwo.vue?vue&type=template&id=5ea5781a&scoped=true&"
import script from "./ProfileTabsTwo.vue?vue&type=script&lang=js&"
export * from "./ProfileTabsTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea5781a",
  null
  
)

export default component.exports